
export const Hasura = () => {
    return (
        <iframe height={"100%"} width={"100%"} style={{border:"none"}}
                src={"/console"} title={"Hasura Console"} />
    )
}